function toggleFooterLanguageSelector(target) {
  const $optionGroup = $(target)
    .closest(".aplenglowee-footer-language-selector")
    .find(".aplenglowee-footer-language-option-group");

  const optionGroupActive = $optionGroup.attr("data-active") === "true";

  $optionGroup.attr("data-active", optionGroupActive ? "false" : "true");

  $(".aplenglowee-footer-language-selector-arrow").attr(
    "data-opened",
    optionGroupActive ? "false" : "true",
  );
}

function closeFooterLanguageSelector() {
  $(".aplenglowee-footer-language-option-group").attr("data-active", false);
  $(".aplenglowee-footer-language-selector-arrow").attr("data-opened", false);
}

$(document).on("click", function (event) {
  if (
    $(event.target).closest(".aplenglowee-footer-language-selector").length ===
    0
  ) {
    $(".aplenglowee-footer-language-option-group").attr("data-active", false);
    $(".aplenglowee-footer-language-selector-arrow").attr("data-opened", false);
  }
});
